import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import {isEmpty, map} from 'lodash';
import moment from 'moment-timezone';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton
} from "react-share";
import check_circle_grey from '../../../../Assets/images/useraccount/check-circle-grey.svg';
import check_circle from '../../../../Assets/images/useraccount/check-circle.svg';
import facebook_referral_icon from '../../../../Assets/images/useraccount/facebook_referral_icon.svg';
import linkedIn_referral_Icon from '../../../../Assets/images/useraccount/linkedIn_referral_Icon.svg';
import twitter_referral_Icon from '../../../../Assets/images/useraccount/twitter_referral_Icon.svg';
import about_img from '../../../../Assets/images/useraccount/about_img.png';
import about_img_2 from '../../../../Assets/images/useraccount/about_img_2.png';
import doodle_dash from '../../../../Assets/images/useraccount/doodle_dash.svg';
import doodle_dash_2 from '../../../../Assets/images/useraccount/doodle_dash_2.svg';
import subscription_about_img from '../../../../Assets/images/subscription_about_img.png';
import pin from '../../../../Assets/images/useraccount/pin.png';
// import CustomerPortalMap from '../../../../Assets/images/CustomerPortalMap.png';
import { message } from 'antd';
import CustomMap from "./CustomMap";
import {errorHandle} from "../../../Common/errorHandle";

// maping STATUS for hardcoded
const STATUS = {
  tentative: 'Tentative',
  scheduled: 'Scheduled',
  technician_assigned: 'Technician Assigned',
  technician_en_route: 'Technician En Route',
  complete: 'Complete',
  cancelled: 'Cancelled',
  forecast: 'Forecast'
};
// maping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
};

// maping frequency  for hardcoded
const PROPERTY_TYPE_MAPPING = {
  townhouse: 'Town House',
  single_family_small: 'Detached (Less than 0.5 acre)',
  single_family_large: 'Detached (More than 0.75 acre)'
}

//Commercial Service
const status2 = {
  pet_waste_station_service: "Pet Waste Station Service",
  common_area_cleaning: "Common Area Cleaning",
  trash_can_service: "Trash Can Service",
  pet_waste_stations: "Pet Waste Stations",
}

let service_route = [{key: 'scheduled', value: 'Scheduled'},
  {key: 'technician_assigned', value: 'Technician assigned'},
  {key: 'technician_en_route', value: 'Technician en route', technician: '', stop_number: ''},
  // {key: 'in_progress', value: 'Service in progress'},
  {key: 'complete', value: 'Service complete!'}]

let MarkePin = () => <div className="marker_wrapper"> <img style={{ 'width': '15px' }} src={pin} alt="" className="pin" /><div className="pulse" /></div>

class AccountOverview extends Component {
  state = {
    is_info_show: false,
    loader: false,
    //account info
    accountInfo: {},
    emailaddress_set: [],
    phone_numbers: [],
    authorized_users: [],
    //message
    message_list: [],

    //service order
    UPASTService: [],
    ServiceData: [],
    refererral_link: '',
    role: [],

    //Invoice
    invoice_data: [],
    payment_data: [],
    service_stats: {},
    selectedMarker: -1,
    service_address_geocode: {},
  }


  componentDidMount = () => {
    let userKey = JSON.parse(localStorage.getItem('userKey')) || null;
    // get user acount info
    this.props.getAccountInfo();
    //get message list
    this.props.getMessagesList({ limit: 4 })

    //Past and Upcoming Services
    this.props.getPastUpcomingService();
    //get service order
    // this.props.getServiceOrder({ limit: 1 });

    // get service stats
    this.props.getServiceStats();

    //get Payment
    this.props.getPayment({ user__uuid: userKey?.user.uuid });
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 800);


    if (userKey) {
      this.setState({
        role: userKey?.user?.role,
        refererral_link: 'refererrals.doodycalls.com/' + userKey?.user?.username
      })

    }
    //Get Invoice Listing
    const accessToken = JSON.parse(localStorage.getItem("userKey"))
      ? JSON.parse(localStorage.getItem("userKey")).user?.uuid
      : "";
    this.setState({
      loader: true
    })
    // this.props.getAccountListing({ limit: 2, offset: 0, user__uuid: accessToken })
    this.props.getInvoiceCreditMemoList({ limit: 3, offset: 0, user__uuid: accessToken })
  }

  UNSAFE_componentWillReceiveProps = (props) => {

    const { ServiceData } = this.state;
    //get account info
    if (Object.keys(props.AccountInfo.data).length > 0 && props.AccountInfo.data !== this.props.AccountInfo.data) {
      this.setState({
        accountInfo: props.AccountInfo.data,
        emailaddress_set: props.AccountInfo.data.emailaddress_set,
        phone_numbers: props.AccountInfo.data.phone_numbers,
        authorized_users: props.AccountInfo.data.authorized_users
      })

      this.arrayMove(
        props.AccountInfo.data['emailaddress_set'],
        props.AccountInfo.data['emailaddress_set'].findIndex((x) => x.primary), 0);
    }
    if (Object.keys(props.AccountInfo.errors).length > 0) {
      //write a code for action on api fail
      this.setState({
        loader: false
      })
    }

    // get message list
    if (Object.keys(props.getMessages.data).length > 0 && props.getMessages.data !== this.props.getMessages.data) {
      this.setState({
        message_list: props.getMessages.data.results
      })
    }
    if (Object.keys(props.getMessages.errors).length > 0 && props.getMessages.errors !== this.props.getMessages.errors) {
      //Display error message here
    }

    // get Past and Upcoming Services
    if (Object.keys(props.UPASTService.data).length > 0 && props.UPASTService.data !== this.props.UPASTService.data) {
      this.setState({
        UPASTService: props.UPASTService.data.services
      })
    }
    if (Object.keys(props.UPASTService.errors).length > 0 && props.UPASTService.errors !== this.props.UPASTService.errors) {
      //Display error message here
    }

    if (Object.keys(props.addBag.data).length > 0 && props.addBag.data !== this.props.addBag.data) {

      //get service order
      // this.props.getServiceOrder({ 'limit': 1 });
    }
    if (Object.keys(props.addBag.errors).length > 0 && props.addBag.errors !== this.props.addBag.errors) {
      //Display error message here
    }

    // Service Order details
    if (props?.serviceOrder && props?.serviceOrder?.data && props?.serviceOrder?.data?.results?.length > 0 && JSON.stringify(props.serviceOrder.data.results) !== JSON.stringify(ServiceData)) {
      const ServiceData = props?.serviceOrder?.data?.results?.length > 0 ? [props?.serviceOrder?.data?.results[0]] : props?.serviceOrder?.data?.results;
      const address_obj =  ServiceData?.[0]?.service_address;
      const address = `${address_obj.address} ${address_obj.city} ${address_obj.state} ${address_obj.zipcode}`
      this.props.resetGeocodeAddress()
      this.props.getGeocodeAddress({key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY, address})
      this.setState({
        ServiceData
      })
    }

    //Get Invoice Details
    // if (Object.keys(props.GetInvoice.data).length > 0 && props.GetInvoice.data !== this.props.GetInvoice.data) {
    //   this.setState({
    //     invoice_data: props.GetInvoice.data.results,
    //     loader: false
    //   })
    // }

    //Get Invoice/Credit Memo Details
    if (Object.keys(props.GetInvoice.InvoiceCreditMemoList).length > 0 && props.GetInvoice.InvoiceCreditMemoList !== this.props.GetInvoice.InvoiceCreditMemoList) {
      this.setState({
        invoice_data: props.GetInvoice.InvoiceCreditMemoList.results,
        loader: false
      })
    }

    if (Object.keys(props.GetInvoice.errors).length > 0 && props.GetInvoice.errors !== this.props.GetInvoice.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
      errorHandle(props?.GetInvoice?.errors)
    }

    //Get Payment
    if (props.GetPayment.data.length > 0 && props.GetPayment.data !== this.props.GetPayment.data) {

      this.setState({
        payment_data: props.GetPayment.data.slice(0, 3),
        loader: false
      })
    }

    if (props.GetPayment.errors.length > 0 && props.GetPayment.errors !== this.props.GetPayment.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
      errorHandle(props?.GetPayment?.errors)
    }

    //get service stats
    if (Object.keys(props?.ServiceStats?.data).length > 0 && props?.ServiceStats?.data !== this.props?.ServiceStats?.data) {

      this.setState({
        service_stats: props?.ServiceStats?.data?.service_allocation,
        loader: false
      })
    }

    if (Object.keys(props?.ServiceStats?.errors).length > 0 && props?.ServiceStats?.errors !== this.props?.ServiceStats?.errors) {
      // display error messsage
      this.setState({
        loader: false
      })
      errorHandle(props?.ServiceStats?.errors)
    }

    // get geocode
    if (Object.keys(props?.GoogleApi?.getGeocode) && JSON.stringify(props?.GoogleApi?.getGeocode) !== JSON.stringify(this.props?.GoogleApi?.getGeocode)) {
      this.setAddress(props?.GoogleApi?.getGeocode)
    }

    this.setState({
      loader: false
    })
  }

  // set address
  setAddress = (addressObject) => {
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        // const {ServiceData} = this.state;
        // const {service_address} = ServiceData?.[0]
        let components = addressObject?.results?.[0];
        // Object.assign(service_address, {geo_location: {latitude: components?.geometry?.location?.lat, longitude: components?.geometry?.location?.lng}})
        // Object.assign(ServiceData?.[0], {service_address})
        this.setState({ service_address_geocode:  components?.geometry?.location });
      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  //show marker info
  ShowMarkerInfo = (selectedMarker) => {
    this.setState({ is_info_show: !this.state.is_info_show, selectedMarker })
  }

  // Set price list as per invision
  arrayMove = (arr, fromIndex, toIndex) => {
    if (fromIndex && fromIndex >= 0) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);

      arr.splice(toIndex, 0, element);
    }
  };

  // Past and Upcoming Services
  renderUpcomingandFastService = () => {
    let { UPASTService } = this.state;
    return map(UPASTService, (item, i) => {
      return (
        <li key={i}>
          <label>{moment(item.scheduled_time).format('ddd, MMM DD')}</label>
          <span>{STATUS[item.status]}</span>
        </li>

      )
    })
  }

  //Render Commercial Map
  renderCommercialMap = (item) => {
    let MAP_OPTIONS = { disableDoubleClickZoom: true, zoomControl: false, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: false }
    console.log("item:::>", item)
    if (item.length > 0) {
      return (
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY }}
          options={MAP_OPTIONS}
          defaultCenter={{ lat: parseFloat(item[0].latitude), lng: parseFloat(item[0].longitude) }}
          defaultZoom={16}
        >
          {
            map(item, (x, i) => {
              return (<MarkePin
                key={i}
                lat={parseFloat(x.latitude)}
                lng={parseFloat(x.longitude)}
              />)
            })
          }
        </GoogleMapReact>
      )
    }

  }
  //Render Map
  renderMap = (item) => {
    let MAP_OPTIONS = { disableDoubleClickZoom: true, zoomControl: false, mapTypeControl: false, scaleControl: false, streetViewControl: false, rotateControl: false, fullscreenControl: false }
    if (item.service_address.geo_location) {
      return (
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY }}
          options={MAP_OPTIONS}
          defaultCenter={{ lat: item?.service_address?.geo_location?.latitude, lng: item?.service_address?.geo_location?.longitude }}
          defaultZoom={15}
        >

          <MarkePin
            lat={item?.service_address?.geo_location?.latitude?.toString()}
            lng={item?.service_address?.geo_location?.longitude?.toString()} />
        </GoogleMapReact>
      )
    }

  }

  //Render Active Service
  renderActiveService = () => {
    let { ServiceData, role } = this.state;
    return map(ServiceData, (item, i) => {
      let _markers = [], multiple_locations = item?.commercial_detail?.multiple_locations, address = item?.service_address
      if (multiple_locations && multiple_locations !== "None") {
        let locations = multiple_locations?.split('MULTIPOINT')[1]
        locations = locations?.trim().substr(1, locations.trim().length - 2)
        let temp = locations?.split(', ')
        map(temp, (obj) => _markers.push({ lat: obj.split(' ')[0], lng: obj.split(' ')[1] }))
      } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
        _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }]
      }

      let frequency = [];
      map(item?.frequency_type?.split(', '), x => x && frequency.push(FREQUENCY_MAPPING[x]))

      return (
        <React.Fragment key={i}>
          {role.includes('commercial_customer') ?

            <div className="service_card active_services ccard">
              <div className="header">
                <span className="title">Active Services</span>
                <a href="/#" onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View <span className="hide-md">Information</span></a>
              </div>
              {/* <img src={CustomerPortalMap} alt='' style={{ width: '100%' }} /> */}
              {
                !isEmpty(_markers) ?
                  <div className="cmap">
                    <CustomMap markers={_markers} />
                  </div> : ''
              }
              
              <div className="cbody">
                <h5>
                  <span className="adpin"></span>&nbsp; &nbsp;
                  <span>{`${item.service_address?.address}, ${item.service_address?.city}, ${item.service_address?.state} ${item.service_address?.zip_code}`}</span>
                </h5>
                <div className="sdetail d-flex ">
                  <div className="scell">
                    <strong>Next Service</strong>
                    <p> {item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : '-'}</p>
                  </div>
                  <div className="scell">
                    <strong>Frequency</strong>
                    <p>{!isEmpty(frequency) ? frequency?.join(', ') : ''}</p>

                  </div>
                  <div className="scell">

                    <strong>Last Service</strong>
                    <p>{item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : '-'}</p>

                  </div>
                </div>
                <div className="sdetail">
                  <div className="subs">
                    <strong>Subscription</strong>
                    <span className=" d-flex justify-content-between">
                      <div>
                        {
                          map(item?.commercial_detail?.line_items, (x, i) => {
                            return (
                              <p key={i}>{`${x.frequency ? FREQUENCY_MAPPING[x.frequency] : ''}${x.frequency ? ' Service, ' : ''}<br/> ${status2[x.item]}`}</p>
                            )
                          })
                        }
                      </div>
                      <strong>${item?.commercial_detail?.total}</strong>
                    </span>
                  </div>
                </div>
                <div className="vtotal  d-flex justify-content-between">
                  <strong>Total per visit</strong>
                  <strong>-</strong>
                </div>
                <div className="btn-grp">

                  <button
                    type="button"
                    onClick={() => {
                      this.props.tabChange(2);
                      localStorage.setItem('is_view_service', JSON.stringify({
                        'service_order__uuid': ServiceData[i]['uuid'],
                        'service_address': ServiceData[i]['service_address']
                      }));

                    }}
                    className="btn btn--secondary w-100">View Service</button>
                </div>
              </div>
            </div>
            :

            <div className="service_card active_services ccard">
              <div className="header">
                <span className="title">Active Services</span>
                <a href="/#" onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View <span className="hide-md"> Information</span></a>
              </div>
              <React.Fragment>

                {item.service_address.geo_location ?
                  <div className="maps">
                    {this.renderMap(item)}
                  </div>
                  : ''}
              </React.Fragment>
              
              <div className="cbody">
                <h5>
                  <span className="adpin"></span>&nbsp; &nbsp;
                  <span>{`${item.service_address.address}, ${item.service_address.city}, ${item.service_address.state} ${item.service_address.zip_code}`}</span>
                </h5>
                <div className="sdetail d-flex ">
                  <div className="scell">
                    <strong>Next Service</strong>
                    <p>{item.next_service_date ? moment(item.next_service_date).format('ddd, MMM DD') : ''}</p>
                  </div>
                  <div className="scell">
                    <strong>Frequency</strong>
                    <p>{FREQUENCY_MAPPING[item.calculated_price.frequency] && FREQUENCY_MAPPING[item.calculated_price.frequency]}</p>

                  </div>
                  <div className="scell">
                    <strong># of Dogs</strong>
                    <p>{item.calculated_price.pet_count}</p>
                  </div>
                </div>

                <div className="sdetail">
                  <div className="subs">
                    <strong>Subscription</strong>
                    <span className=" d-flex justify-content-between">
                      <p>
                        {FREQUENCY_MAPPING[item.calculated_price.frequency]}&nbsp; service, {PROPERTY_TYPE_MAPPING[item.calculated_price.property_type] && PROPERTY_TYPE_MAPPING[item.calculated_price.property_type]},<br/> {item.calculated_price.pet_count} dogs</p>
                      <strong>${item.calculated_price.service_base_price}</strong>
                    </span>
                  </div>
                  <div className="subs">
                    <strong>Add On</strong>
                    <span className=" d-flex justify-content-between">

                      {item.calculated_price.recurring_add_ons.recurring_addon_items.length > 0 ?
                        <React.Fragment>
                          <p>
                            {map(item.calculated_price.recurring_add_ons
                              && item.calculated_price.recurring_add_ons.recurring_addon_items, (a) => {
                              return `${a.name}, `
                            })}
({FREQUENCY_MAPPING[item.calculated_price.frequency]})
                          </p>
                          <strong>${item.calculated_price.recurring_add_ons.total_recurring_addon_cost}</strong>
                        </React.Fragment> : '-'}

                    </span>
                  </div>
                </div>
                <React.Fragment>
                  <div className="vtotal  d-flex justify-content-between">
                    <strong>Total per visit</strong>
                    <strong>${item.calculated_price.total_price_per_service}</strong>
                  </div>
                  <div className="btn-grp d-flex justify-content-between">
                    <button type="button" className="btn btn--secondary d-flex justify-content-center hide-btn" onClick={() => {
                      this.props.tabChange(6);
                      localStorage.setItem('is_edit_request', JSON.stringify({ 'is_edit_request': true }));
                    }}>Edit &nbsp;<span className="hide-btn">Service</span></button>
                    <button type="button" className="show-md btn btn--secondary d-flex justify-content-center show-btn"
                      onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View </button>
                    <button className="btn btn--secondary" onClick={() => {
                      this.props.tabChange(2);
                      localStorage.setItem('is_pause_service', JSON.stringify({
                        'service_order__uuid': ServiceData[i]['uuid'],
                        'service_address': ServiceData[i]['service_address']
                      }));
                    }} >Pause Service</button>
                  </div>
                </React.Fragment>
              </div>
            </div>
          }
        </React.Fragment>
      )
    })

  }

  // render service stats
  renderServiceStats = (stat, index) => {
    const {service_stats} = this.state;
    const is_include = service_stats?.status?.includes(stat?.key)
    const is_next_include = service_stats?.status?.includes(service_route?.[index + 1]?.key)
    const is_show_next_service = (service_stats?.length === 1 && service_stats?.status?.includes('scheduled'))
    let service_completed_stop = []
    map(service_stats?.routes, x => {
      if (x.service_completed === false) service_completed_stop.push(x.stop_number)
    })

    return (
      <li key={`Stats${index}`}>
        {index === (service_route?.length - 1) ? '' : <div className={`border_line ${is_next_include ? 'active_border_line' : ''}`}></div>}
        <div className="icon_img">
          <img src={is_include ? check_circle : check_circle_grey} alt="" />
        </div>
        <div className="commnet_details">
          <label className={is_include ? '' : 'waiting'}>{stat?.value}</label>
          {(is_show_next_service && stat?.next_service) ? <p><b>Next service: {stat?.next_service}</b></p> : ''}
          {!isEmpty(stat?.technician) ? <p><b>{`${stat?.technician?.first_name || ''} ${stat?.technician?.last_name || ''}`}</b>{` is ${service_completed_stop?.length} stops away!`}</p> : ''}
        </div>
      </li>
    )
  }

  render() {
    let { accountInfo, emailaddress_set, phone_numbers, message_list, refererral_link, ServiceData, loader, role, invoice_data, payment_data, service_stats, service_address_geocode } = this.state;
    let UserDetails = JSON.parse(localStorage.getItem('userKey')) || null;
    let _markers = []

    const next_service = moment().format('ddd, MMM D')
    const technician_name = `${service_stats?.technician?.first_name || ''} ${service_stats?.technician?.last_name?.substr(0, 1) || ''}`
    const tech_en_route_idx = service_route.findIndex(x => x?.key === 'technician_en_route')
    Object.assign(service_route[tech_en_route_idx], {technician: service_stats?.technician || {}, stop_number: service_stats?.route?.stop_number || ''})
    const schedule_idx = service_route.findIndex(x => x?.key === 'scheduled')
    Object.assign(service_route[schedule_idx], {next_service})

    if (!isEmpty(service_stats?.routes)) {
      _markers = service_stats?.routes?.map(x => ({lat: x?.latitude, lng: x?.longitude}))
    } else {
      // lat: 41.8737831
      // lng: -87.67294419999999
      _markers = [service_address_geocode]
      const isEmptyMarkers = !isEmpty(_markers) ? Object.values(_markers?.[0]).every(x => (x === null || x === undefined)) : false

      if (isEmptyMarkers) {
        _markers = []
      }
    }

    // for display sentence from DOOD-1111
    let current_user_stop = service_stats?.routes?.[service_stats?.routes?.length - 1]?.stop_number || ''
    let service_completed_stop = []
    if (!isEmpty(service_stats?.routes)) {
      map(service_stats?.routes, x => {
        if (x.service_completed === true) service_completed_stop.push(x.stop_number)
      }) 
    }
    ////

    return (
      <React.Fragment>
        <div className="container">
          <div className="account_overview">

            <div className="row card-column">
              <div className="col-md-12 col-lg-3 card">
                <div className="service_card scheduled_card">
                  <ul className="scheduled_listing">
                    {map(service_route, this.renderServiceStats)}
                  </ul>
                  {!isEmpty(service_stats?.routes) ? <div>
                    <label><b>{`You are stop number ${current_user_stop} and Technician is at stop number ${service_completed_stop}`}</b></label>
                  </div> : ''}
                  <div className="contact">
                    <label> Questions? <a href="/#" onClick={(e) => { e.preventDefault(e); this.props.tabChange(6) }}>Contact us today</a></label>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-5 card">
                <div className="service_card live_map_tracking">
                  <div id="map">
                    {!isEmpty(_markers) ?
                      <CustomMap
                        markers={_markers}
                        containerStyle={{height: "301px"}}
                        onMarkerClick={(selectedMarker) => this.ShowMarkerInfo(selectedMarker)}
                      /> : ''}
                    {(!(service_stats?.length === 3 && service_stats?.status?.includes('in_progress'))) ?
                      <div className="login_user_name">
                        <div className="dog_img">
                          <img src={doodle_dash} alt=""/>
                          <span
                            className="username">{UserDetails?.user?.is_first_login ? 'Welcome' : 'Welcome back'}, {UserDetails && UserDetails.user && UserDetails.user.first_name ? UserDetails.user.first_name : 'Tom'}!</span>
                        </div>
                      </div> : ''
                    }
                    {isEmpty(service_stats) ? <div className="overlay_desc" style={{display: 'flex', height: "10%", top: "90%", borderRadius: "0px"}}>
                      <div className="overlay_details">
                        <label>You have no scheduled services.</label>
                        {/*<span>Get your free quote today!</span>*/}
                      </div>
                    </div> : (service_stats?.length === 1 && service_stats?.status?.includes('scheduled')) ? <div className="overlay_desc" style={{display: 'flex'}}>
                      <div className="overlay_details">
                        <label>We are just assigning your technician...</label>
                        <span>Next service: {next_service}</span>
                      </div>
                    </div> : (service_stats?.length === 3 && service_stats?.status?.includes('in_progress')) ?
                      <div className="marker_info">
                        <div className="login_user_wrapper">
                          <div className="login_user_name">
                            <div className="dog_img">
                              <img src={doodle_dash_2} alt="" />
                              <div className="details">
                                <span className="message">{technician_name} is due to arrive at</span>
                                <span className="time"> approx. {moment().format('hh:mm a')}</span>
                              </div>
                            </div>
                          </div>
                          <div className="technician_img">
                            <img src={service_stats?.technician?.photo || subscription_about_img} alt="" />
                          </div>
                          <div className="technician_details">
                            <label>{technician_name} · Technician</label>
                            <span>{service_stats?.technician?.description || ''}</span>
                          </div>
                        </div>
                      </div> : ''}
                    {/*                    {(service_stats?.length === 1 && service_stats?.status?.includes('scheduled')) ? <div className="overlay_desc">
                      <div className="overlay_details">
                        <label>We are just assigning your technician...</label>
                        <span>Next service: {next_service}</span>
                      </div>
                    </div>: ''}
                    {(service_stats?.length === 3 && service_stats?.status?.includes('in_progress')) ?
                      <div className="marker_info">
                        <div className="login_user_wrapper">
                          <div className="login_user_name">
                            <div className="dog_img">
                              <img src={doodle_dash_2} alt="" />
                              <div className="details">
                                <span className="message">{technician_name} is due to arrive at</span>
                                <span className="time"> approx. {moment().format('hh:mm a')}</span>
                              </div>
                            </div>
                          </div>
                          <div className="technician_img">
                            <img src={service_stats?.technician?.photo || subscription_about_img} alt="" />
                          </div>
                          <div className="technician_details">
                            <label>{technician_name} · Technician</label>
                            <span>{service_stats?.technician?.description || ''}</span>
                          </div>
                        </div>
                      </div> : ''}*/}
                  </div>

                </div>
              </div>
              <div className="col-md-12 col-lg-4 card">
                <div className="service_card upcoming_service">
                  <h2>Past and Upcoming Services</h2>
                  <ul className="upcoming_service_list">
                    {this.renderUpcomingandFastService()}
                  </ul>
                  <div className="border"></div>
                  <ul className="upcoming_service_list paused_service">

                    {/* Pause Service will be display here once get from API */}
                    {/* <li>
                      <label>Fri, May 2</label>
                      <span>Paused</span>
                    </li> */}

                  </ul>
                  {
                    map(ServiceData, (item, i) => {
                      return (
                        <div className="btn-grp" key={i}>
                          <button
                            key={i}
                            className="btn btn--secondary"
                            onClick={() => {
                              this.props.tabChange(2);
                              localStorage.setItem('is_view_service', JSON.stringify({
                                'service_order__uuid': ServiceData[i]['uuid'],
                                'service_address': ServiceData[i]['service_address']
                              }));
                            }}
                          >View past and future services</button>
                        </div>
                      )
                    })
                  }

                </div>
              </div>

              <div className="col-md-12 col-lg-4 card">
                <div className="service_card account_info">
                  <div className="header">
                    <span className="title">Account Info</span>
                    <a href="/#" onClick={(e) => { e.preventDefault(); this.props.tabChange(1) }}>View <span className="hide-md">Account Information</span></a>
                  </div>
                  <div className="body">
                    <div className="account_info_table">
                      <table>
                        <thead>
                          <tr>
                            <th>Primary User:</th>
                            <th>{accountInfo ? `${accountInfo.first_name || '-'} ${accountInfo.last_name || '-'}` : ""}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Authorized Users:</td>
                            <td>{accountInfo.authorized_users && accountInfo.authorized_users.length > 0 ? accountInfo.authorized_users.join(',') : '-'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <label className="email">{
                      !isEmpty(emailaddress_set) ?
                        map(emailaddress_set && emailaddress_set, (item) => {
                          if (item.primary) {
                            return item.email
                          }
                        }) : accountInfo?.email
                    } (Primary)
                    </label>
                    <label className="phone">{map(phone_numbers && phone_numbers, (item) => {
                      if (item.primary) {
                        return `${this.formatPhoneNumber(item.phone)} (Primary)`
                      }
                    })
                    }</label>
                  </div>
                </div>
                {this.renderActiveService()}
              </div>
              <div className="col-md-12 col-lg-4 card">
                <div className="service_card my_invoce">
                  <div className="header">
                    <span className="title">Invoices and Payments</span>
                    <a href="/#" onClick={(e) => { e.preventDefault(e); this.props.tabChange(5); }}>View <span className="hide-md"></span></a>
                  </div>
                  <div className="body">
                    <div className="recent_invoice">
                      <h2 className="title">Recent Invoices</h2>
                      <div className="details">

                        {invoice_data.length > 0 ?
                          <table className="table">
                            <tbody>
                              {map(invoice_data, (item, i) => {

                                return (
                                  <tr className={item?.status === 'overdue' ? 'danger' : ''} key={i}>
                                    <td><label className="date">{moment(item?.invoice_date?item?.invoice_date:item?.date_creditmemo).format("MMMM DD, YYYY")}</label></td>
                                    <td><label className="amount">${item.creditmemo_id && item.remaining_balance>0?"-":null}{item?.invoice_date?item?.balance_due:item?.remaining_balance}</label></td>
                                    <td><label className="status">{item?.status}</label></td>
                                  </tr>
                                )
                              })}



                            </tbody>
                          </table> :
                          <div className="no_data">
                            <p>You have no recent invoices.</p>
                          </div>}
                      </div>
                    </div>
                    <div className="border_line"></div>
                    <div className="recent_payment">
                      <div className="title_wrapper">
                        <h2 className="title">Recent Payments</h2>
                        <a href="/#" onClick={(e) => { e.preventDefault(e); this.props.tabChange(5); }}>View <span className="hide-md">Payments</span></a>
                      </div>
                      <div className="details">
                        {payment_data.length > 0 ?
                          <table className="table">
                            <tbody>
                              {map(payment_data, (item, i) => {
                                return (
                                  <tr key={i}>
                                    <td><label className="date">
                                      {item?.created_at ? moment(item?.created_at).format('MMMM DD, YYYY') : ''}</label></td>
                                    <td><label className="amount">
                                      ${item?.amount}
                                    </label></td>
                                    <td><label className="status">{item?.payment_mode}</label></td>
                                  </tr>
                                )
                              })}

                            </tbody>
                          </table> : <div className="no_data">
                            <p>You have no recent payments.</p>
                          </div>}
                      </div>
                    </div>
                    <div className="border_line"></div>
                    <div className="recent_overdue">
                      {accountInfo?.invoice_overdue > 0 ?
                        <React.Fragment>
                          <label className="warning_label">There is an overdue balance of ..</label>
                          <div className="details">

                            <label>{accountInfo?.invoice_overdue ? `$ ${accountInfo?.invoice_overdue}` : 0}</label>
                            <span>SUSPENDED</span>
                            <p>24 days over due</p>
                          </div>
                        </React.Fragment> : <div className="details"><div className="no_data"> <p style={{ color: '#8E0A0A' }}>You have no overdue balances.</p></div></div>}

                    </div>
                  </div>
                </div>
                <div className="message service_card">
                  <div className="header">
                    <h2 className="title">Messages</h2>
                    <a href="/#" onClick={(e) => { e.preventDefault(e); this.props.tabChange(6) }}>View <span className="hide-md">My Messages</span></a>
                  </div>
                  <div className="body">
                    <div className="recent_messages">
                      <h2 className="title">Recent Messages</h2>
                      {message_list.length > 0 ?
                        < table className="table">
                          <tbody>
                            {map(message_list, (item, i) => {
                              return (
                                <tr className={item.status === 'open' ? 'success' : ''} key={i}>
                                  <td width="50%">
                                    <label className="message">{item.title}</label>
                                  </td>
                                  <td width="15%">
                                    <label className="status" style={{ 'whiteSpace': 'pre' }}>{!item.read_by_staff_user ? 'Awaiting Reply' : ''}</label>
                                  </td>
                                  <td width="15%">
                                    <label className="action">{item.status}</label>
                                  </td>
                                </tr>
                              )
                            })}

                          </tbody>
                        </table>
                        : <div className="no_data">
                          <p>You have no recent messages.</p>
                        </div>}
                      <div className="button_section">

                        <React.Fragment>
                          <button className="btn btn--secondary" onClick={(e) => {
                            e.preventDefault(e);
                            //tab change
                            this.props.tabChange(6);
                            localStorage.setItem('is_new_messages', JSON.stringify({ 'is_new_messages': true }));
                          }}>Contact Us</button>
                          {message_list.length > 0 ? <button className="btn btn-outline--primary" onClick={(e) => { e.preventDefault(e); this.props.tabChange(6) }}>Clear <span>closed</span> tickets</button> : ''}
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-4 card">
                {role.includes('commercial_customer') ? '' :
                  <div className="doggie_bags service_card show-md">
                    <h2>Need doggie clean-up bags?</h2>
                    <p>Deliver 200 doggie clean-up bags with my next service</p>
                    {
                      map(ServiceData, (item, i) => {

                        return (
                          < button
                            key={i}
                            className="btn btn--secondary"
                            disabled={item.next_service_bags}
                            onClick={() => {
                              this.setState({ loader: true }); this.props.addServiceBag({
                                'service_order_uuid': item.uuid,
                                'add_bags': '8.99'
                              })
                            }}
                          > {item.next_service_bags ? 'Bag Added' : 'Add bags + $8.99'}</button>
                        )
                      })
                    }
                  </div>
                }


                <div className="doggie_bags service_card">
                  {role.includes('commercial_customer') ?
                    <React.Fragment>
                      <h2>Need an extra service in your community?</h2>
                      <p>Request a one-time cleaning for a special occasion</p>
                      <button className="btn btn--secondary"
                        onClick={() => {
                          this.props.tabChange(6);
                          localStorage.setItem('is_request_one_time', JSON.stringify({ 'is_request_one_time': true }));
                        }}
                      >Request one-time service</button>
                    </React.Fragment>
                    :

                    <React.Fragment>
                      <h2>Need an extra service?</h2>
                      <p>Request a one-time cleaning for a special occasion</p>
                      <button className="btn btn--secondary"
                        onClick={() => {
                          this.props.tabChange(6);
                          localStorage.setItem('is_request_one_time', JSON.stringify({ 'is_request_one_time': true }));
                        }}
                      >Request one-time service</button>
                    </React.Fragment>
                  }
                </div>

                <div className="social_card service_card show-md">
                  {role.includes('commercial_customer') ?
                    ''
                    :
                    <div className="first_section">
                      <h2 className="title">Know someone who hates scooping poop?</h2>
                      <p className="desc">Share DoodyCalls with a friend and you’ll get one free visit after their first service is complete.</p>

                      <input type="text"
                        className="form--control"
                        name=""
                        disabled
                        placeholder={refererral_link} />
                      <ul className="social_list">
                        <li>
                          <FacebookShareButton url='refererrals.doodycalls.com/TomB' quote={"DoodyCalls"} className="share">
                            <a href="/#" onClick={(e) => { e.preventDefault(e) }}><img src={facebook_referral_icon} alt='' /></a>
                          </FacebookShareButton>
                        </li>
                        <li>
                          <TwitterShareButton url='refererrals.doodycalls.com/TomB' title='DoodyCalls' hashtags={['DoodyCalls']}>
                            <a href="/#" onClick={(e) => { e.preventDefault(e) }}><img src={twitter_referral_Icon} alt='' /></a>
                          </TwitterShareButton>
                        </li>
                        <li>
                          <LinkedinShareButton url='refererrals.doodycalls.com/TomB'>
                            <a href="/#" onClick={(e) => { e.preventDefault(e) }}><img src={linkedIn_referral_Icon} alt='' /></a>
                          </LinkedinShareButton>
                        </li>
                        <li>
                          <a href="/#" onClick={(e) => {
                            e.preventDefault(e);
                            navigator.clipboard.writeText(refererral_link).then(function () {
                              message.destroy();
                              message.success('Link copy successfully')
                            }, function (err) {
                              console.error('Async: Could not copy text: ', err);
                            });
                          }} className="btn btn-outline--primary">Copy Link</a>
                        </li>
                      </ul>
                    </div>
                  }
                  <div className="second_section">
                    {role.includes('commercial_customer') ?
                      <React.Fragment>
                        <b className="title">How was your service?</b>
                        <p className="desc">Write us a review and be entered to win a YEAR of free service!</p>
                      </React.Fragment>
                      :
                      <p className="desc">… or write us a review and be entered to win a YEAR of free service!</p>
                    }
                    <div className="button_section">
                      <a
                        href="https://www.yelp.com/biz/doodycalls-san-mateo-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline--primary" >Review on Yelp</a>
                      <a
                        href="https://www.google.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline--primary ml-2" >Review on Google</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
        {/* <div className="container abt-bg">
          <div className="account_overview">
            <div className="row">
              <div className="col-md-12">
                <div className="about_detail">
                  {role.includes('commercial_customer') ?
                    <div className="about_img_section">
                      <img src={about_img_2} alt="" />
                      <div className="text_details">
                        <h2>Continue to enjoy your local Communial Area’s</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        <div className="button_section">
                          <button className="btn btn--secondary">CTA for Promo</button>
                          <button className="btn btn-outline--primary">Refer XXX</button>
                        </div>
                      </div>
                    </div>
                    :
                    <div className="about_img_section">
                      <img src={about_img} alt="" />
                      <div className="text_details">
                        <h2>In need of a service at home?</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                        <div className="button_section">
                          <button className="btn btn--secondary">CTA for Promo</button>
                          <button className="btn btn-outline--primary">Refer XXX</button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {
          loader ?
            <div className='loader_wrapper'>
              < div className='loader07' ></div >
            </div >
            : ''
        }
      </React.Fragment >
    );
  }
}

export default AccountOverview;